import { useState } from 'react';
import useGet from '../../Hooks/useGet';
import API_ENDPOINTS from '../../Config/api';
import Selector from './../UI/Selector';

export default function CreateEditAsset({ onclose, onSubmit, defaultAsset = null }) {
  const [assetType, setAssetType] = useState(defaultAsset?.tipo_asset?.toLowerCase() || 'dominio');
  const [assetName, setAssetName] = useState(defaultAsset?.asset || '');
  const [registrationDate, setRegistrationDate] = useState(defaultAsset?.data_registrazione || new Date());
  const [expiryDate, setExpiryDate] = useState(defaultAsset?.data_scadenza || '');
  const [error, setError] = useState('');
  const { fetchedData: aziendaDettagli } = useGet(API_ENDPOINTS.aziendaDettagli);

  // Genera placeholder in base al tipo di asset selezionato
  const getPlaceholder = () => {
    switch (assetType) {
      case 'email':
        return 'es. nome@esempio.com';
      case 'dominio':
        return 'es. example.com';
      case 'ip':
        return 'es. 192.168.0.1';
      default:
        return 'Inserisci Nome...';
    }
  };

  const validateAssetName = () => {
    if (assetType === 'email') {
      const emailRegex = /^\S+@\S+\.\S+$/;
      if (!emailRegex.test(assetName)) {
        return 'Email non valida';
      }
    }
    if (assetType === 'dominio') {
      const domainRegex = /^[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z]{2,}$/;
      if (!domainRegex.test(assetName)) {
        return 'Dominio non valido';
      }
    }
    if (assetType === 'ip') {
      const ipRegex = /^((25[0-5]|2[0-4]\d|[01]?\d?\d)\.){3}(25[0-5]|2[0-4]\d|[01]?\d?\d)$/;
      if (!ipRegex.test(assetName)) {
        return 'Indirizzo IP non valido';
      }
    }
    return '';
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const validationError = validateAssetName();
    if (validationError) {
      setError(validationError);
      return;
    }
    setError('');
    onSubmit?.({
      id_azienda: aziendaDettagli?.id_azienda,
      tipo_asset: assetType,
      asset: assetName,
      flag_attivo: true,
      data_registrazione: registrationDate.toISOString().slice(0, 10),
      data_scadenza: expiryDate || null,
    });
  };

  const filterOption = [
    { label: 'Dominio', value: 'dominio' },
    { label: 'IP', value: 'ip' },
    { label: 'Email', value: 'email' },
  ]

  return (
    <form
      onSubmit={handleSubmit}
      className="bg-white shadow-lg rounded-lg p-6 max-w-xl mx-auto"
    >
      <h2 className="text-2xl font-semibold text-gray-800 mb-6">
        {defaultAsset ? 'Modifica Asset' : 'Crea Nuovo Asset'}
      </h2>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
        {/* Tipo Asset */}
        <div className="flex flex-col">
          <label
            htmlFor="assetType"
            className="mb-2 text-gray-700 font-medium"
          >
            Tipo Asset
          </label>
          <Selector options={filterOption} onChange={setAssetType} value={assetType} width='w-38' />
        </div>
        {/* Nome Asset */}
        <div className="flex flex-col">
          <label
            htmlFor="assetName"
            className="mb-2 text-gray-700 font-medium"
          >
            Nome Asset
          </label>
          <input
            id="assetName"
            type="text"
            value={assetName}
            onChange={(e) => setAssetName(e.target.value)}
            placeholder={getPlaceholder()}
            required
            className="border border-gray-300 rounded-md px-4 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
          />
          {error && (
            <p className="mt-1 text-sm text-red-600">{error}</p>
          )}
        </div>
      </div>

      {assetType === 'dominio' && aziendaDettagli?.email && (
        <p className="mt-4 text-xs text-gray-500">
          Invieremo il link di autorizzazione all&apos;email di registrazione: <strong>{aziendaDettagli.email}</strong>.
        </p>
      )}

      <div className="mt-8 flex justify-between">
        <button
          type="button"
          onClick={onclose}
          className="w-32 px-4 py-2 bg-white border border-gray-300 rounded-md text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-400 text-center"
        >
          Annulla
        </button>
        <button
          type="submit"
          className="w-32 px-4 py-2 bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 text-white font-semibold rounded-md transition text-center"
        >
          Salva Asset
        </button>
      </div>
    </form>
  );
}
